import { EResponseStatus } from '@enums';

import { IAppState } from '@stores';

import { fetchData as baseFetchData } from '@base/decorators';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchData = (actions: Function[]): (target: any) => void => {
	actions.push(async ({ countersStore, mainMenuAppsStore, currentUserStore, uiStore }: IAppState) => {
		const currentUser = currentUserStore?.currentUser || null;
		const myApps = mainMenuAppsStore.myApps;
		const suggestApps = mainMenuAppsStore.suggestApps;

		if (uiStore?.isOnline) {
			if (currentUser?.isMyCreated) {
				// стор для левого меню
				if ((!myApps.length || !suggestApps.length) && mainMenuAppsStore.status !== EResponseStatus.OK) {
					try {
						await mainMenuAppsStore.fetch();
					} catch (err) {}
				}
				// стор для счётчиков
				if (!countersStore || countersStore.status === null) {
					const options = { user: currentUser, isMobile: true };

					await countersStore.fetch(options);
				}
			}
		}
	});

	return baseFetchData(actions);
};
